import { forwardRef, Ref } from "react"

import styled from 'styled-components'

export const Wrapper = styled.div<{
  
  $position?: string,
  $boxSizing?: 'border-box'
  $t?: string, 
  $l?: string, 
  $w?: string, 
  $h?: string, 
  $bgColor?: string, 
  $zIndex?: string,

  $bRad?: string
  $btlRad?: string,
  $btrRad?: string,
  $bblRad?: string,
  $bbrRad?: string,

  $m?: string,
  $mt?: string,
  $mr?: string,
  $mb?: string,
  $ml?: string,

  $btColor?: string,
  $brColor?: string,
  $bbColor?: string,
  $blColor?: string,

  $btWidth?: string,
  $brWidth?: string,
  $bbWidth?: string,
  $blWidth?: string,

  $btStyle?: 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden',
  $brStyle?: 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden',
  $bbStyle?: 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden',
  $blStyle?: 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden',

  $p?: string,
  $pt?: string,
  $pr?: string,
  $pb?: string,
  $pl?: string,

  $boxShadow?: string,
  $color?: string, 
  cursor?: 'pointer' | 'none'
  $display?: 'flex' | 'inline-flex' | 'block' | 'inline-block' | 'grid',
  $alignItems?: 'normal'|'stretch'|'center'|'start'|'end'|'flex-start'|'flex-end'|'baseline'|'initial'|'inherit'
  $justifyContent?: 'flex-start' | 'flex-end' | 'center'|'space-between'|'space-around'|'space-evenly'|'initial'|'inherit'
}>`
  ${props => props.$position ? 'position: ' + props.$position + '; ' : ''}
  ${props => props.$boxSizing ? 'box-sizing: ' + props.$boxSizing + '; ' : ''}
  ${props => props.$t ? 'top: ' + props.$t + '; ' : ''}
  ${props => props.$l ? 'left: ' + props.$l + '; ' : ''}
  ${props => props.$w ? 'width: ' + props.$w + '; ' : ''}
  ${props => props.$h ? 'height: ' + props.$h + '; ' : ''}
  ${props => props.$bgColor ? 'background-color: ' + props.$bgColor + '; ' : ''}
  ${props => props.$zIndex ? 'z-index: ' + props.$zIndex + '; ' : ''}
  ${props => props.$bRad ? 'border-radius: ' + props.$bRad + '; ' : ''}
  ${props => props.$btlRad ? 'border-top-left-radius: ' + props.$btlRad + '; ' : ''}
  ${props => props.$btrRad ? 'border-top-right-radius: ' + props.$btrRad + '; ' : ''}
  ${props => props.$bblRad ? 'border-bottom-left-radius: ' + props.$bblRad + '; ' : ''}
  ${props => props.$bbrRad ? 'border-bottom-right-radius: ' + props.$bbrRad + '; ' : ''}
  ${props => props.$m ? 'margin: ' + props.$m + '; ' : ''}
  ${props => props.$mt ? 'margin-top: ' + props.$mt + '; ' : ''}
  ${props => props.$mr ? 'margin-right: ' + props.$mr + '; ' : ''}
  ${props => props.$mb ? 'margin-bottom: ' + props.$mb + '; ' : ''}
  ${props => props.$ml ? 'margin-left: ' + props.$ml + '; ' : ''}
  ${props => props.$btColor ? 'border-top-color: ' + props.$btColor + '; ' : ''}
  ${props => props.$brColor ? 'border-right-color: ' + props.$brColor + '; ' : ''}
  ${props => props.$bbColor ? 'border-bottom-color: ' + props.$bbColor + '; ' : ''}
  ${props => props.$blColor ? 'border-left-color: ' + props.$blColor + '; ' : ''}
  ${props => props.$btWidth ? 'border-top-width: ' + props.$btWidth + '; ' : ''}
  ${props => props.$brWidth ? 'border-right-width: ' + props.$brWidth + '; ' : ''}
  ${props => props.$bbWidth ? 'border-bottom-width: ' + props.$bbWidth + '; ' : ''}
  ${props => props.$blWidth ? 'border-left-width: ' + props.$blWidth + '; ' : ''}
  ${props => props.$btStyle ? 'border-top-style: ' + props.$btStyle + '; ' : ''}
  ${props => props.$brStyle ? 'border-right-style: ' + props.$brStyle + '; ' : ''}
  ${props => props.$bbStyle ? 'border-bottom-style: ' + props.$bbStyle + '; ' : ''}
  ${props => props.$blStyle ? 'border-left-style: ' + props.$blStyle + '; ' : ''}
  ${props => props.$p ? 'padding: ' + props.$p + '; ' : ''}
  ${props => props.$pt ? 'padding-top: ' + props.$pt + '; ' : ''}
  ${props => props.$pr ? 'padding-right: ' + props.$pr + '; ' : ''}
  ${props => props.$pb ? 'padding-bottom: ' + props.$pb + '; ' : ''}
  ${props => props.$pl ? 'padding-left: ' + props.$pl + '; ' : ''}

  ${props => props.cursor ? 'cursor: ' + props.cursor + ';': ''}
  ${props => props.$boxShadow ? 'box-shadow: ' + props.$boxShadow + '; ' : ''}
  ${props => props.$color ? 'color: ' + props.$color + '; ' : ''}
  ${props => props.$display ? 'display: ' + props.$display + '; ' : ''}
  ${props => props.$alignItems ? 'align-items: ' + props.$alignItems + '; ' : ''}
  ${props => props.$justifyContent ? 'justify-content: ' + props.$justifyContent + '; ' : ''}

`

interface BoxDivProps<T extends HTMLDivElement>
  extends React.HTMLProps<T> {
    position?: string,
    boxSizing?: 'border-box',
    t?: string,
    l?: string,
    w?: string, 
    h?: string,
    bgColor?: string, 
    zIndex?: string,
  
    bRad?: string,
    btlRad?: string,
    btrRad?: string,
    bblRad?: string,
    bbrRad?: string,
  
    m?: string,
    mt?: string,
    mr?: string,
    mb?: string,
    ml?: string,
  
    btColor?: string,
    brColor?: string,
    bbColor?: string,
    blColor?: string,
  
    btWidth?: string,
    brWidth?: string,
    bbWidth?: string,
    blWidth?: string,
  
    btStyle?: 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden',
    brStyle?: 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden',
    bbStyle?: 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden',
    blStyle?: 'dotted' | 'dashed' | 'solid' | 'double' | 'groove' | 'ridge' | 'inset' | 'outset' | 'none' | 'hidden',
  
    p?: string,
    pt?: string,
    pr?: string,
    pb?: string,
    pl?: string,
  
    cursor?: 'pointer' | 'none'
    boxShadow?: string,
    color?: string, 
    display?: 'flex' | 'inline-flex' | 'block' | 'inline-block' | 'grid',
    alignItems?: 'normal'|'stretch'|'center'|'start'|'end'|'flex-start'|'flex-end'|'baseline'|'initial'|'inherit',
    justifyContent?: 'flex-start' | 'flex-end' | 'center'|'space-between'|'space-around'|'space-evenly'|'initial'|'inherit',
}
/**
 * 
 * 
 * Various box shadows:
 * xs: '0 0 5px rgba(255, 0, 0, 0.5)',
  sm: '0 1px 2px rgba(0, 255, 0, 0.5)',
  base: '0 1px 3px rgba(0, 0, 255, 0.5)',
  md: '0 4px 6px rgba(255, 0, 255, 0.5)',
  lg: '0 10px 15px rgba(255, 255, 0, 0.5)', // full on man
  xl: '0 20px 25px rgba(0, 255, 255, 0.5)',
  '2xl': '0 25px 50px rgba(255, 255, 255, 0.5)',
  'dark-lg': '0 20px 25px rgba(0, 0, 0, 0.5)',
  outline: '0 0 0 3px rgba(66, 153, 225, 0.6)',
  inner: 'inset 0 2px 4px 0 rgba(255, 255, 255, 0.5)',
 * 
 * 
 * 
 * 
 * @param param0 
 * @returns 
 */
export const Box = forwardRef(<T extends HTMLDivElement>(props: BoxDivProps<T>, ref:Ref<HTMLDivElement>) => {

  return <Wrapper {...ref} $position={props.position} $boxSizing={props.boxSizing} $t={props.t} $l={props.l} $w={props.w} $h={props.h} $bgColor={props.bgColor} $zIndex={props.zIndex} 
  $bRad={props.bRad} $btlRad={props.btlRad} $btrRad={props.btrRad} $bblRad={props.bblRad} $bbrRad={props.bbrRad}
  $m={props.m} $mt={props.mt} $mr={props.mr} $mb={props.mb} $ml={props.ml} 
  $btColor={props.btColor} $brColor={props.brColor} $bbColor={props.bbColor} $blColor={props.blColor} 
  $btWidth={props.btWidth} $brWidth={props.brWidth} $bbWidth={props.bbWidth} $blWidth={props.blWidth} 
  $btStyle={props.btStyle} $brStyle={props.brStyle} $bbStyle={props.bbStyle} $blStyle={props.blStyle} 
  $p={props.p} $pt={props.pt} $pr={props.pr} $pb={props.pb} $pl={props.pl} 
  $boxShadow={props.boxShadow} $color={props.color} $display={props.display} $alignItems={props.alignItems} $justifyContent={props.justifyContent}>
    {props.children}
  </Wrapper>
});